import { CommonStore } from "../store/CommonStore";
import { APIBASEURL } from "../consts/common";
import { useStore } from "../store/SessionLiffStore";
import axios from "axios";
import {
  addressResponse,
  bankInfoResponse,
  userDetailResponse,
  userSnsAccountResponse,
} from "../types/apiResponse";
import {
  addressRegistRequest,
  bankInfoRequest,
  updateUserSnsAccountRequest,
} from "../types/apiRequest";
import { UserInfoStore } from "../store/UserInfoStore";
import * as Sentry from "@sentry/vue";

axios.defaults.headers.common["x-api-key"] =
  "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4";

axios.defaults.headers.common["AxiosAccess-Control-Allow-Origin"] = "*";

// 新規登録
// lineのアクセストークンの情報だけ登録する（ユーザー名等の登録はユーザー情報更新APIから）
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const signUp = async () => {
  const userInfoStore = UserInfoStore();
  userInfoStore.setUserDetail(undefined);
  const commonStore = CommonStore();
  const liff = useStore();
  const data = {
    line_access_token: liff.lineAccessToken,
    line_user_id: liff.lineUserId,
  };

  return await axios.post(APIBASEURL + "signup/", data).then((res) => {
    commonStore.setToken(res.data.data.token);
    localStorage.setItem("token", res.data.data.token);
    // 再登録時は古いトークンが残っている場合があるため、トークンをセットし直す
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
  });
};

// ログイン
// tokenがあるかないかない場合は新規ユーザー、t
//  tokenない場合はサインイン試みる
//  ユーザーが見つかればトークン保存 持ってなければ新規ユーザーか機種変ユーザー
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const signIn = async (resign?: boolean): Promise<any> => {
  const liff = useStore();
  const commonStore = CommonStore();
  // ローカルにトークンがないもしくは新規・再登録
  if (!(localStorage.getItem("token") || resign)) {
    return await axios
      .get(APIBASEURL + "signin/", {
        headers: {
          Authorization:
            localStorage.getItem("liffToken") || liff.lineAccessToken,
          "Content-Type": "application/json",
          "x-api-key":
            "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
          "Access-Control-Allow-Origin": "*",
        },
        params: {
          line_access_token: liff.lineAccessToken,
          line_user_id: liff.lineUserId,
        },
      })
      .then((res) => {
        commonStore.setToken(res.data.data.token);

        if (res.data.data.token) {
          localStorage.setItem("token", res.data.data.token);
        }
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${localStorage.getItem("token")}`;
        return;
      })
      .catch((e) => {
        return e;
      });
  }
};

export const getUserDetail = async (): Promise<
  userDetailResponse | undefined
> => {
  const liff = useStore();
  return axios
    .get(APIBASEURL + "me", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      Sentry.setUser({
        id: res.data.data.id,
        email: res.data.data.email,
        nickname: res.data.data.name,
        name: res.data.data.last_name + res.data.data.first_name,
      });
      return JSON.parse(JSON.stringify(res.data.data));
    })
    .catch(() => {
      return undefined;
    });
};

// ユーザー情報更新
export const updateUserInfo = async (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params: any
): Promise<userDetailResponse | undefined> => {
  // const commonStore = CommonStore();
  // if (localStorage.getItem("token")) return;
  const data = params;
  const liff = useStore();
  return await axios
    .put(APIBASEURL + "me", data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      if (res.data.status == 200) {
        return JSON.parse(JSON.stringify(res.data.data));
      } else {
        return undefined;
      }
      // commonStore.setToken(res.data.data.token);
      // localStorage.setItem("token", res.data.data.token);
    })
    .catch(() => {
      return undefined;
    });
};

// 銀行口座情報取得
export const getBankInfo = async (): Promise<bankInfoResponse | undefined> => {
  const liff = useStore();
  const res = await axios
    .get(APIBASEURL + "me/bank", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      return res;
    });
  return res ? JSON.parse(JSON.stringify(res.data.data)) : undefined;
};

// 銀行口座情報更新
export const updateBankInfo = async (
  req: bankInfoRequest
): Promise<bankInfoResponse | undefined> => {
  const liff = useStore();
  const res = await axios.put(APIBASEURL + "me/bank", req, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
      "x-api-key":
        "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
      "Access-Control-Allow-Origin": "*",
    },
    params: {
      line_user_id: liff.lineUserId,
    },
  });
  return JSON.parse(JSON.stringify(res.data.data)) || undefined;
};
// 銀行口座情報削除
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteBankInfo = async (): Promise<any> => {
  const liff = useStore();
  return await axios
    .delete(APIBASEURL + "me/bank", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((v) => {
      return JSON.parse(JSON.stringify(v));
    })
    .catch((e) => {
      return JSON.parse(JSON.stringify(e.response.data));
    });
};

// 退会
export const withdrawal = async (
  reason: string
): Promise<{
  result: boolean;
  message: string;
  state: number;
}> => {
  const commonStore = CommonStore();
  const userInfoStore = UserInfoStore();
  let result = false;
  let messsage = "";
  let state = 0;
  const request = {
    reason: reason,
  };
  if (localStorage.getItem("token")) result = false;
  await axios
    .delete(APIBASEURL + "me", {
      data: request,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Methods":
          "POST, GET, OPTIONS, PUT, DELETE, PATCH",
        credentials: "same-origin",
        "Access-Control-Allow-Headers":
          "Accept, Content-Type, Content-Length, Accept-Encoding, X-CSRF-Token, Authorization",
      },
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .then((res: any) => {
      if (res.data.status == 200) {
        commonStore.setToken("");
        userInfoStore.setUserDetail(undefined);
        result = true;
        messsage =
          "退会処理が完了しました\r\nご利用いただきありがとうございました";
        state = 0;
      } else if (res.data.status == 400) {
        result = true;
        messsage = res.error.message;
        state = 1;
      }
    })
    .catch((e) => {
      result = false;
      messsage =
        e.response.data.error.message ||
        "退会処理に失敗しました。運営にお問い合わせください";
      state = 1;
    });
  return {
    result: result,
    message: messsage,
    state: state,
  };
};
// ユーザーSNSNアカウント取得
export const getUserSnsInfo = async (): Promise<
  userSnsAccountResponse[] | undefined
> => {
  const liff = useStore();
  const res = await axios.get(APIBASEURL + "me/social_media_accounts", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
      "x-api-key":
        "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
      "Access-Control-Allow-Origin": "*",
    },
    params: {
      line_user_id: liff.lineUserId,
    },
  });
  return JSON.parse(JSON.stringify(res.data.data)) || undefined;
};
// ユーザーSNSNアカウント更新
export const updateUserSnsInfo = async (
  req: updateUserSnsAccountRequest
): Promise<userSnsAccountResponse> => {
  const liff = useStore();
  const params: updateUserSnsAccountRequest = req;
  const res = await axios.put(APIBASEURL + "me/social_media_accounts", params, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
      "x-api-key":
        "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
      "Access-Control-Allow-Origin": "*",
    },
    params: {
      line_user_id: liff.lineUserId,
    },
  });
  return JSON.parse(JSON.stringify(res.data.data)) || undefined;
};
// ユーザーSNSNアカウント削除
export const deleteUserSnsInfo = async (req: number): Promise<boolean> => {
  const liff = useStore();
  // const params: updateUserSnsAccountRequest = req;
  const res = await axios.delete(
    APIBASEURL + `me/social_media_accounts?media_type=${req}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    }
  );
  return JSON.parse(JSON.stringify(res.data.status)) == 200 || false;
};

// 配送先住所取得
export const getAddressInfo = async (): Promise<
  addressResponse | undefined
> => {
  const liff = useStore();
  const res = await axios
    .get(APIBASEURL + "me/address", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .catch(() => {
      return undefined;
    });
  return res ? JSON.parse(JSON.stringify(res.data.data)) : undefined;
};

// 配送先住所更新
export const updateAddressInfo = async (
  req: addressRegistRequest
): Promise<addressResponse | undefined> => {
  const liff = useStore();
  return await signIn(true)
    .then(async () => {
      const res = await axios.put(APIBASEURL + "me/address", req, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          "x-api-key":
            "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
          "Access-Control-Allow-Origin": "*",
        },
        params: {
          line_user_id: liff.lineUserId,
        },
      });
      return JSON.parse(JSON.stringify(res.data.data)) || undefined;
    })
    .catch(() => {
      return undefined;
    });
};
// 配送先住所削除
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteAddressInfo = async (): Promise<any> => {
  const liff = useStore();
  return await axios
    .delete(APIBASEURL + "me/address", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((v) => {
      return JSON.parse(JSON.stringify(v));
    })
    .catch((e) => {
      return JSON.parse(JSON.stringify(e.response.data));
    });
};
